export const downloadPDF = (path, filename) => {
  const anchor = document.createElement("a");
  anchor.href = path;
  anchor.target = "_blank";
  if (filename) {
    anchor.download = filename;
  }

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
};
